import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const BdelUpdate = lazy(() => import('@/pages/mngt/ext/BdelUpdate'));
const VrUpdate = lazy(() => import('@/pages/mngt/ext/VrUpdate'));
const ConstructionUpdate = lazy(() => import('@/pages/mngt/ext/ConstructionUpdate'));
const ConstructionDetail = lazy(() => import('@/pages/mngt/ext/ConstructionDetail'));
const ConstructionEdit = lazy(() => import('@/pages/mngt/ext/ConstructionEdit'));
const ConstructionCreate = lazy(() => import('@/pages/mngt/ext/ConstructionCreate'));

const extRoutes: RouteObject[] = [
  {
    path: '/mngt/bdel',
    element: <BdelUpdate />
  },
  {
    path: '/mngt/vr',
    element: <VrUpdate />
  },
  {
    path: '/mngt/construction',
    element: <ConstructionUpdate />,
    // element: withSuspense(<ConstructionUpdate />),
    children: [
      // {
      //   path: ':id',
      //   element: withSuspense(<BoardDetail />)
      // },
      // {
      //   path: 'create',
      //   element: withSuspense(<ConstructionCreate />)
      // }
      // {
      //   path: 'edit/:id',
      //   element: withSuspense(<BoardEdit />)
      // }
    ]
  },
  {
    path: '/mngt/construction/:id',
    element: <ConstructionDetail />
  },
  {
    path: '/mngt/construction/:id/edit',
    element: <ConstructionEdit />
  },
  {
    path: '/mngt/construction/create',
    element: <ConstructionCreate />
  }
];

export default extRoutes;
